import { useGetInflammagingDetailV2 } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { InflammagingDetailResponse } from '@viome/viome-base/src/usecase/Health/Health.model';
import { HealthDetailPage } from '@/components/shared/ReuseableHealthDeatil';
import { JourneyEducationTypes } from '@utils/JourneyEducationTypes';
import {
  getImflammingAnimationFromLocal,
  getImflammingOverlayImage,
} from '@/utils/health/getAnimation';
import { ErrorLoadingPage } from '../ErrorHandling/ErrorLoadingPage';

export const InflammagingPage = () => {
  const { data, isLoading, isError } = useGetInflammagingDetailV2();

  if (isError) {
    return <ErrorLoadingPage variant="dark" />;
  }

  const {
    about = 'Information not available.',
    message = 'No message provided.',
    rank = 'Attention',
    rank_color = '#FFFFFF',
    trend = [],
    title = 'Unknown Title',
  }: Partial<InflammagingDetailResponse> = data || {};

  return (
    <HealthDetailPage
      data={{
        title,
        about,
        mainStat: String(message),
        subStat: rank,
        rankColor: rank_color,
        inflammagingTrend: trend,
        size: 'lg',
        overlayImg: getImflammingOverlayImage(message),
        videoSrc: getImflammingAnimationFromLocal(message),
      }}
      isLongvietySection
      journeyDeeperSectionInfo={JourneyEducationTypes.INFLAMMAGING_DETAIL}
      isLoading={isLoading || !data}
      screen="imflammaging"
    />
  );
};
